import styled from 'styled-components'
import { giphyRed } from '@giphy/colors'
const Beta = styled.div`
    color: white;
    font-weight: bold;
`
import { Icon } from './logo'
type Props = {
    onLogoClick?: () => void
}
const BetaHeader = ({ onLogoClick }: Props) => {
    return (
        <>
            <Icon />
            <Beta onClick={() => onLogoClick?.()}>
                BETA | using <span style={{ color: giphyRed }}>production</span> data
            </Beta>
        </>
    )
}
export default BetaHeader
